import type { QuizBuilderBasicInfoSchema } from '@repo/schemas/quiz/quizBuilder';

import { cn } from '@repo/lib/cn';

import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { useQuizBuilder } from '@/context/quiz-builder';

export default function QuizBuilderBasicInfoPage() {
  const { submitBasicInfo, basicInfoForm } = useQuizBuilder();

  const onSubmit = (data: QuizBuilderBasicInfoSchema) => {
    submitBasicInfo(data);
  };

  return (
    <div className="grow overflow-auto p-4">
      <h1 className="mb-2 text-xl font-semibold">Utwórz Nowy Quiz</h1>
      <p className="text-text-tertiary mb-6 text-sm">Wypełnij podstawowe informacje o quizie i przejdź dalej.</p>
      <Form {...basicInfoForm}>
        <form onSubmit={basicInfoForm.handleSubmit(onSubmit)}>
          <FormField
            name={'name'}
            control={basicInfoForm.control}
            render={({ field }) => (
              <FormItem className={'w-full'}>
                <FormLabel>Nazwa</FormLabel>
                <FormControl>
                  <Input placeholder={'Nazwa'} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            name={'desc'}
            control={basicInfoForm.control}
            render={({ field }) => (
              <FormItem className={'w-full'}>
                <FormLabel>
                  Opis <small className={'text-text-tertiary text-sm'}>(opcionalne)</small>
                </FormLabel>
                <FormControl>
                  <Textarea
                    placeholder={'Opis'}
                    {...field}
                    value={field.value ?? ''}
                    onChange={(event) => {
                      const value = event.target.value;
                      field.onChange(value ? value : null);
                    }}
                    className={'min-h-32'}
                  />
                </FormControl>
                <FormDescription className={cn('text-xs', field.value?.length && field.value?.length > 255 && 'text-text-destructive')}>{field.value?.length || 0}/255 znaków</FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />
        </form>
      </Form>
    </div>
  );
}
